import { Link } from "react-router-dom";
import { Clock } from "lucide-react";
import type { ModuleKey } from "@gaole/shared";
import { moduleLabel } from "@gaole/shared";
import { EmptyState, Button } from "../ui";

export function ModuleComingSoon({ module }: { module: ModuleKey }) {
  return (
    <div className="px-4 pt-4">
      <EmptyState
        icon={Clock}
        title={`${moduleLabel(module)} coming soon`}
        hint="This feature isn't available yet — check back later."
        action={
          <Link to="/">
            <Button variant="outline">Back to home</Button>
          </Link>
        }
      />
    </div>
  );
}
